import { EffectIndex } from '@/define/define'
import { LightEffectModeType } from '@/define/light'
import { DeviceManager } from '@/service/device'
import { DevicePid } from '@/define/define'
import firmware from '@/upgrade/firmware'
import { Fe87v2DeviceList, Fe87C18DeviceList } from '@/define/device_vendor'
import { LIGHT_EFFECT_LIST_PRO_V140, LIGHT_EFFECT_LIST_PRO_V130, LIGHT_EFFECT_LIST_FE87V2_V212, LIGHT_EFFECT_LIST_FE87V2_V215, LIGHT_EFFECT_LIST_FE87_C18_V105 } from './light/light_effect_list'

export async function lightDataByVersion(lightEffectList: { [name: LightEffectModeType]: number }): Promise<{ [name: LightEffectModeType]: number }> {
  if ([...devicePro, ...deviceCyan, ...Fe87v2DeviceList].includes(DeviceManager.instance.state.currentPid) == false) {
    return lightEffectList
  }
  const fwVersionBetween104106 = await firmware.fwVersionBetween('1.0.4', '1.0.6', devicePro)
  if (fwVersionBetween104106) {
    return lightEffectList_140
  }
  const fwVersionLessThan112 = await firmware.fwVersionLessThan('1.1.2', deviceCyan)
  if (fwVersionLessThan112) {
    return lightEffectList_140
  }
  const fwVersionLessThan104 = await firmware.fwVersionLessThan('1.0.4', devicePro)
  if (fwVersionLessThan104) {
    return lightEffectList_130
  }
  const fwVersionGT215 = await firmware.fwVersionGreaterThanOrEqual('2.1.5', [...Fe87v2DeviceList])
  if (fwVersionGT215) {
    return LIGHT_EFFECT_LIST_FE87V2_V215
  }
  const fwVersionGT212 = await firmware.fwVersionGreaterThanOrEqual('2.1.2', [...Fe87v2DeviceList])
  if (fwVersionGT212) {
    return LIGHT_EFFECT_LIST_FE87V2_V212
  }
  const fwVersionGT105_C18 = await firmware.fwVersionGreaterThanOrEqual('1.0.5', Fe87C18DeviceList)
  if (fwVersionGT105_C18) {
    return LIGHT_EFFECT_LIST_FE87_C18_V105
  }
  return lightEffectList
}

export const devicePro: DevicePid[] = [DevicePid.IROKNa87Pro, DevicePid.IROKNd63, DevicePid.IYXMu68Pro]

const deviceCyan: DevicePid[] = [DevicePid.IROKNd63_cyan, DevicePid.IYXMu68Pro_cyan]

const lightEffectList_130: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_PRO_V130

const lightEffectList_140: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_PRO_V140
